// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__MDy8U.styles_ocean-50__CYTJw {
  color: #e6f2ff;
}

.styles_color__MDy8U.styles_ocean-100__i7AWd {
  color: #e6f2ff;
}

.styles_color__MDy8U.styles_ocean-200__bkpbF {
  color: #b3daff;
}

.styles_color__MDy8U.styles_ocean-300__RIjSJ {
  color: #7abfff;
}

.styles_color__MDy8U.styles_ocean-400__93xHD {
  color: #2392fb;
}

.styles_color__MDy8U.styles_ocean-500__95HWs {
  color: #0074e0;
}

.styles_color__MDy8U.styles_ocean-600__cprRJ {
  color: #043571;
}

.styles_color__MDy8U.styles_space-50__EKpxQ {
  color: #f0f0f0;
}

.styles_color__MDy8U.styles_space-100__pr2Tp {
  color: #e3e3e3;
}

.styles_color__MDy8U.styles_space-200__Lrt-5 {
  color: #bfbfbf;
}

.styles_color__MDy8U.styles_space-300__96VbM {
  color: gray;
}

.styles_color__MDy8U.styles_space-400__FfBlx {
  color: #616161;
}

.styles_color__MDy8U.styles_space-500__xP62c {
  color: #283439;
}

.styles_color__MDy8U.styles_gray-50__1emED {
  color: #eff3f6;
}

.styles_color__MDy8U.styles_gray-100__eJuru {
  color: #e6ecef;
}

.styles_color__MDy8U.styles_gray-200__nNxG5 {
  color: #cfd8de;
}

.styles_color__MDy8U.styles_gray-300__T3h4S {
  color: #a8b9c2;
}

.styles_color__MDy8U.styles_gray-400__1z5QJ {
  color: #7e98a5;
}

.styles_color__MDy8U.styles_gray-500__sdCo\\+ {
  color: #738f9c;
}

.styles_color__MDy8U.styles_green-50__opZSn {
  color: #e3fdf6;
}

.styles_color__MDy8U.styles_green-100__3iM6U {
  color: #c5f6ea;
}

.styles_color__MDy8U.styles_green-200__hLxv1 {
  color: #69ddc2;
}

.styles_color__MDy8U.styles_green-300__uZ5pw {
  color: #45bfa3;
}

.styles_color__MDy8U.styles_green-400__qB12T {
  color: #1cab8a;
}

.styles_color__MDy8U.styles_green-500__Ox4Jx {
  color: #128268;
}

.styles_color__MDy8U.styles_red-50__glRCJ {
  color: #fff0f3;
}

.styles_color__MDy8U.styles_red-100__szSkA {
  color: #f9d2db;
}

.styles_color__MDy8U.styles_red-200__KmLHR {
  color: #f8b4c4;
}

.styles_color__MDy8U.styles_red-300__dZy19 {
  color: #e85e81;
}

.styles_color__MDy8U.styles_red-400__yd8j7 {
  color: #e23661;
}

.styles_color__MDy8U.styles_red-500__CjX7- {
  color: #b82348;
}

.styles_color__MDy8U.styles_yellow-50__g7s41 {
  color: #fffae6;
}

.styles_color__MDy8U.styles_yellow-100__139tR {
  color: #fff0b3;
}

.styles_color__MDy8U.styles_yellow-200__e4fUp {
  color: #ffe380;
}

.styles_color__MDy8U.styles_yellow-300__4v5Yc {
  color: #ffcf57;
}

.styles_color__MDy8U.styles_yellow-400__yiZ39 {
  color: #ffc60a;
}

.styles_color__MDy8U.styles_yellow-500__bObcf {
  color: #ffb700;
}

.styles_color__MDy8U.styles_orange-50__8xFnT {
  color: #fff2eb;
}

.styles_color__MDy8U.styles_orange-100__\\+08TY {
  color: #ffe4d6;
}

.styles_color__MDy8U.styles_orange-200__q2KGU {
  color: #ffc69e;
}

.styles_color__MDy8U.styles_orange-300__fHECF {
  color: #ffa047;
}

.styles_color__MDy8U.styles_orange-400__Fn6fA {
  color: #ff7b42;
}

.styles_color__MDy8U.styles_orange-500__RhMMy {
  color: #ee4920;
}

.styles_color__MDy8U.styles_turquoise-50__Ikd5l {
  color: transparent;
}

.styles_color__MDy8U.styles_turquoise-100__vnhgG {
  color: #e6fcff;
}

.styles_color__MDy8U.styles_turquoise-200__zfwIL {
  color: #b3f5ff;
}

.styles_color__MDy8U.styles_turquoise-300__Hznle {
  color: #78e2f2;
}

.styles_color__MDy8U.styles_turquoise-400__29lhZ {
  color: #00c7e6;
}

.styles_color__MDy8U.styles_turquoise-500__Wucdt {
  color: transparent;
}

.styles_color__MDy8U.styles_turquoise-600__R0UIY {
  color: transparent;
}

.styles_color__MDy8U.styles_violet-50__ayrj5 {
  color: #eae6ff;
}

.styles_color__MDy8U.styles_violet-100__SSqx5 {
  color: #d9d1ff;
}

.styles_color__MDy8U.styles_violet-200__KU7NO {
  color: #bfb3ff;
}

.styles_color__MDy8U.styles_violet-300__8a8Uj {
  color: #9d90ea;
}

.styles_color__MDy8U.styles_violet-400__fIx8S {
  color: #8678d9;
}

.styles_color__MDy8U.styles_violet-500__ou3Yp {
  color: #6f5ccc;
}

.styles_color__MDy8U.styles_snow-50__4uDvl {
  color: white;
}

.styles_color__MDy8U.styles_snow-100__H2eds {
  color: #f7f7f7;
}

.styles_color__MDy8U.styles_snow-200__\\+5EIo {
  color: #f0efef;
}

.styles_color__MDy8U.styles_snow-300__bbDw4 {
  color: #e6e6e6;
}

.styles_color__MDy8U.styles_snow-400__TSCve {
  color: #e1e0e0;
}

.styles_color__MDy8U.styles_snow-500__1fHZD {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__t2XXv.styles_ocean__DF7VI {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__t2XXv.styles_ocean-light__G8-np {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__t2XXv.styles_green__X6G\\+E {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__t2XXv.styles_green-light__N7hrC {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__t2XXv.styles_red__v5vDR {
  background-color: #e23661;
  color: white;
}

.styles_background-color__t2XXv.styles_red-light__-awWy {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__t2XXv.styles_orange__OMQDw {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__t2XXv.styles_orange-light__X0BEd {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__t2XXv.styles_space__DaL3k {
  background-color: #616161;
  color: white;
}

.styles_background-color__t2XXv.styles_space-light__pasie {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__t2XXv.styles_gray-light__5MUcF {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__t2XXv.styles_violet__kS-YC {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__t2XXv.styles_violet-light__4DEfE {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__t2XXv.styles_yellow__NXy3t {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__t2XXv.styles_yellow-light__\\+1qwU {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_loadingBarWrapper__plYok {
  height: 100%;
  overflow: hidden;
}

.styles_icon__PWrXR {
  color: white;
  margin-bottom: 14px ;
  text-align: center;
}

.styles_loadingText__qrwtn {
  font-weight: 500;
  font-size: 1.1428571429rem;
  letter-spacing: -0.18px;
  line-height: 24px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  color: white;
  text-align: center;
}

.styles_parentOverlay__mLdOD {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1000;
}

.styles_overCallScreen__3Oq6a {
  z-index: 2000;
}

.styles_hideInline__c\\+1eS {
  visibility: hidden;
}

.styles_backdropLight__lfMqt {
  background: rgba(230, 230, 230, 0.8);
}

.styles_backdropDark__CT-Kb {
  background: rgba(0, 0, 0, 0.8);
}

.styles_errorWrapper__hX0ql {
  display: flex;
  height: 100%;
  width: 100%;
}

.styles_error__WkpQb {
  background: white;
  border-radius: 5px;
  height: 300px;
  margin: auto;
  width: 500px;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/loading/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,YAAA;EACA,gBAAA;AA0UJ;;AAvUA;EACI,YAAA;EACA,oBAAA;EACA,kBAAA;AA0UJ;;AAvUA;EEuCI,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFWrB,YAAA;EACA,kBAAA;AA6UJ;;AA1UA;EACI,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;AA6UJ;;AA1UA;EACI,aAAA;AA6UJ;;AA1UA;EACI,kBAAA;AA6UJ;;AA1UA;EACI,oCAAA;AA6UJ;;AA1UA;EACI,8BAAA;AA6UJ;;AA1UA;EACI,aAAA;EACA,YAAA;EACA,WAAA;AA6UJ;;AA1UA;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AA6UJ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.loadingBarWrapper {\n    height: 100%;\n    overflow: hidden;\n}\n\n.icon {\n    color: theme.color(snow-50);\n    margin-bottom: theme.spacing(1.75);\n    text-align: center;\n}\n\n.loadingText {\n    @include theme.typo(h5);\n\n    color: theme.color(snow-50);\n    text-align: center;\n}\n\n.parentOverlay {\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: theme.get-z-index(loading-parent-overlay);\n}\n\n.overCallScreen {\n    z-index: theme.get-z-index(loading-parent-overlay-over-call-screen);\n}\n\n.hideInline {\n    visibility: hidden;\n}\n\n.backdropLight {\n    background: rgba(230, 230, 230, 0.8);\n}\n\n.backdropDark {\n    background: rgba(0, 0, 0, 0.8);\n}\n\n.errorWrapper {\n    display: flex;\n    height: 100%;\n    width: 100%;\n}\n\n.error {\n    background: theme.color(snow-50);\n    border-radius: theme.get-border-radius(md);\n    height: 300px;\n    margin: auto;\n    width: 500px;\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__MDy8U`,
	"ocean-50": `styles_ocean-50__CYTJw`,
	"ocean-100": `styles_ocean-100__i7AWd`,
	"ocean-200": `styles_ocean-200__bkpbF`,
	"ocean-300": `styles_ocean-300__RIjSJ`,
	"ocean-400": `styles_ocean-400__93xHD`,
	"ocean-500": `styles_ocean-500__95HWs`,
	"ocean-600": `styles_ocean-600__cprRJ`,
	"space-50": `styles_space-50__EKpxQ`,
	"space-100": `styles_space-100__pr2Tp`,
	"space-200": `styles_space-200__Lrt-5`,
	"space-300": `styles_space-300__96VbM`,
	"space-400": `styles_space-400__FfBlx`,
	"space-500": `styles_space-500__xP62c`,
	"gray-50": `styles_gray-50__1emED`,
	"gray-100": `styles_gray-100__eJuru`,
	"gray-200": `styles_gray-200__nNxG5`,
	"gray-300": `styles_gray-300__T3h4S`,
	"gray-400": `styles_gray-400__1z5QJ`,
	"gray-500": `styles_gray-500__sdCo+`,
	"green-50": `styles_green-50__opZSn`,
	"green-100": `styles_green-100__3iM6U`,
	"green-200": `styles_green-200__hLxv1`,
	"green-300": `styles_green-300__uZ5pw`,
	"green-400": `styles_green-400__qB12T`,
	"green-500": `styles_green-500__Ox4Jx`,
	"red-50": `styles_red-50__glRCJ`,
	"red-100": `styles_red-100__szSkA`,
	"red-200": `styles_red-200__KmLHR`,
	"red-300": `styles_red-300__dZy19`,
	"red-400": `styles_red-400__yd8j7`,
	"red-500": `styles_red-500__CjX7-`,
	"yellow-50": `styles_yellow-50__g7s41`,
	"yellow-100": `styles_yellow-100__139tR`,
	"yellow-200": `styles_yellow-200__e4fUp`,
	"yellow-300": `styles_yellow-300__4v5Yc`,
	"yellow-400": `styles_yellow-400__yiZ39`,
	"yellow-500": `styles_yellow-500__bObcf`,
	"orange-50": `styles_orange-50__8xFnT`,
	"orange-100": `styles_orange-100__+08TY`,
	"orange-200": `styles_orange-200__q2KGU`,
	"orange-300": `styles_orange-300__fHECF`,
	"orange-400": `styles_orange-400__Fn6fA`,
	"orange-500": `styles_orange-500__RhMMy`,
	"turquoise-50": `styles_turquoise-50__Ikd5l`,
	"turquoise-100": `styles_turquoise-100__vnhgG`,
	"turquoise-200": `styles_turquoise-200__zfwIL`,
	"turquoise-300": `styles_turquoise-300__Hznle`,
	"turquoise-400": `styles_turquoise-400__29lhZ`,
	"turquoise-500": `styles_turquoise-500__Wucdt`,
	"turquoise-600": `styles_turquoise-600__R0UIY`,
	"violet-50": `styles_violet-50__ayrj5`,
	"violet-100": `styles_violet-100__SSqx5`,
	"violet-200": `styles_violet-200__KU7NO`,
	"violet-300": `styles_violet-300__8a8Uj`,
	"violet-400": `styles_violet-400__fIx8S`,
	"violet-500": `styles_violet-500__ou3Yp`,
	"snow-50": `styles_snow-50__4uDvl`,
	"snow-100": `styles_snow-100__H2eds`,
	"snow-200": `styles_snow-200__+5EIo`,
	"snow-300": `styles_snow-300__bbDw4`,
	"snow-400": `styles_snow-400__TSCve`,
	"snow-500": `styles_snow-500__1fHZD`,
	"background-color": `styles_background-color__t2XXv`,
	"ocean": `styles_ocean__DF7VI`,
	"ocean-light": `styles_ocean-light__G8-np`,
	"green": `styles_green__X6G+E`,
	"green-light": `styles_green-light__N7hrC`,
	"red": `styles_red__v5vDR`,
	"red-light": `styles_red-light__-awWy`,
	"orange": `styles_orange__OMQDw`,
	"orange-light": `styles_orange-light__X0BEd`,
	"space": `styles_space__DaL3k`,
	"space-light": `styles_space-light__pasie`,
	"gray-light": `styles_gray-light__5MUcF`,
	"violet": `styles_violet__kS-YC`,
	"violet-light": `styles_violet-light__4DEfE`,
	"yellow": `styles_yellow__NXy3t`,
	"yellow-light": `styles_yellow-light__+1qwU`,
	"loadingBarWrapper": `styles_loadingBarWrapper__plYok`,
	"icon": `styles_icon__PWrXR`,
	"loadingText": `styles_loadingText__qrwtn`,
	"parentOverlay": `styles_parentOverlay__mLdOD`,
	"overCallScreen": `styles_overCallScreen__3Oq6a`,
	"hideInline": `styles_hideInline__c+1eS`,
	"backdropLight": `styles_backdropLight__lfMqt`,
	"backdropDark": `styles_backdropDark__CT-Kb`,
	"errorWrapper": `styles_errorWrapper__hX0ql`,
	"error": `styles_error__WkpQb`
};
export default ___CSS_LOADER_EXPORT___;
